import { type TaxConstructor } from '../../entities/Tax'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mapTaxApiModel = (data: TaxApiModel): TaxConstructor => ({
  id: data.id,
  description: data.description,
  isActive: data.is_active,
  isDefault: data.is_default,
  isInclusive: data.is_inclusive,
  name: data.name,
  percentage: data.percentage,
})
